import { useContext } from 'react';
import GuiContext from './context/guiContext';
const useBaseUrl = () => {
    const { URL } = useContext(GuiContext);

    return URL;
};

export default useBaseUrl;